import React from 'react';
import Logo from '../assets/images/logo.webp';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Column 1 - Logo + Info */}
          <div className="footer-col footer-col-1">
            <div className="footer-logo-top">
              <img src={Logo} alt="Paul Gold Logo" className="footer-logo-img" />
            </div>
            <p className="footer-brand-subtitle">Paul Gold - A product of</p>
            <p className="footer-brand-subtitle">Paul Merchants Finance Pvt Ltd</p>
            <div className="footer-address">
              <p>SCO 829-830, Sector 22 A</p>
              <p>Chandigarh-160022</p>
              <p>India 160002</p>
            </div>
          </div>

          {/* Column 2 - Email + Phone */}
          <div className="footer-col footer-col-2">
            <h4 className="footer-heading">Email</h4>
            <p className="footer-email">info@paulmerchants.net</p>

            <h4 className="footer-heading">Phone</h4>
            <p className="footer-phone">1800-137-1444</p>
            <p className="footer-timing">(9AM-8PM IST, Mon-Sat)</p>
          </div>

          {/* Column 3 - Social Links */}
          <div className="footer-col footer-col-3">
            <h4 className="footer-heading">Follow Us</h4>
            <div className="footer-social-links">
              <a href="#" className="footer-social-link">Facebook</a>
              <a href="#" className="footer-social-link">Instagram</a>
              <a href="#" className="footer-social-link">LinkedIn</a>
              <a href="#" className="footer-social-link">YouTube</a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">© Paul Gold - Paul Merchants Finance Pvt Ltd 2025. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;